import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { ColorRing } from 'react-loader-spinner';
import QuestionsContainer from '../common/QuestionsContainer';
import { getRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './AddLocationOnProposal.scss';

const renderSpinner = () => (
  <ColorRing
    visible
    height="20"
    width="20"
    ariaLabel="blocks-loading"
    wrapperStyle={{}}
    wrapperClass="updating-icon me-2"
    colors={Array(5).fill('#FFFFFF')}
  />
);

class AddLocationOnProposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      location: props.location,
      saveDisabled: false,
    };

    this.getLocation = this.getLocation.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleToggleSave = this.handleToggleSave.bind(this);
  }

  getLocation() {
    const { questionIds, questionableId, questionableType } = this.props;
    this.setState({ saveDisabled: true });

    getRequest(
      `/question_answers/${questionIds[0]}`,
      { questionable_id: questionableId, questionable_type: questionableType },
    ).then((response) => {
      analyticsTrack('Update location', { location: 'Proposal View' });
      this.setState({
        location: response.data.answer,
        showModal: false,
        saveDisabled: false,
      });
    });
  }

  handleToggleSave(saveDisabled) {
    this.setState({ saveDisabled });
  }

  toggleModal() {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  }

  render() {
    const {
      questionnaireName,
      questionIds,
      questionableId,
      questionableType,
      csrfToken,
      isOwner,
    } = this.props;
    const { showModal, location, saveDisabled } = this.state;

    return (
      <div className="style-guide proposal-location mb-15 body-text-2">
        <Modal
          dialogClassName="proposal-location-modal"
          className="style-guide"
          show={showModal}
          onHide={this.toggleModal}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <QuestionsContainer
              questionnaireName={questionnaireName}
              questionIds={questionIds}
              questionableId={questionableId}
              questionableType={questionableType}
              csrfToken={csrfToken}
              owner={isOwner}
              handleToggleSave={this.handleToggleSave}
            />
            <div className="text-center">
              <Button
                variant="primary"
                onClick={this.getLocation}
                disabled={saveDisabled}
                className={`save-button ${saveDisabled ? 'with-spinner' : ''}`}
              >
                { saveDisabled && renderSpinner() }
                Save
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {
          location
            ? (
              <div>
                <i className="fas fa-map-marker-alt mr-5" />
                {location}
                {' '}
                <a
                  role="button"
                  tabIndex={0}
                  onClick={this.toggleModal}
                >
                  (Update)
                </a>
              </div>
            )
            : (
              <a
                role="button"
                tabIndex={0}
                onClick={this.toggleModal}
              >
                Enter current location
              </a>
            )
        }
      </div>
    );
  }
}

AddLocationOnProposal.propTypes = {
  location: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  isOwner: PropTypes.bool.isRequired,
};

AddLocationOnProposal.defaultProps = {
  location: null,
};

export default AddLocationOnProposal;
